export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13676.13c5e068.jpg";